// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"dc3ad2b7","488":"6ef953bb","613":"b31b8530","977":"484dcb56"}[chunkId] + ".chunk.js";
};